export default __webpack_public_path__ + "static/media/info.9376d75f.svg";